// extracted by mini-css-extract-plugin
module.exports = {"row":"Dashboard_row__391Qt","subheading":"Dashboard_subheading__14dAL","noRoundsDiv":"Dashboard_noRoundsDiv__3v7od","rightCol":"Dashboard_rightCol__gKVQT"};